<div #inputElement class="pl-timepicker h-[48px]" [class.form-submitted]="isFormSubmitted">
  <mat-form-field
    appearance="outline"
    class="h-[48px] w-full cursor-pointer"
    [ngClass]="{
      'pointer-events-none': isDisabled
    }"
    floatLabel="always"
    subscriptSizing="dynamic"
    (click)="openDropdownToSelectTime()"
  >
    <mat-label *ngIf="label">{{ label }}</mat-label>
    <div class="flex h-full items-center justify-between">
      <input
        [attr.aria-label]="label"
        matInput
        class="pl-timepicker-input grow rounded-md p-2.5 outline-none !caret-current"
        [ngClass]="{
          'cursor-pointer': !isDisabled
        }"
        [id]="identifier"
        [readonly]="true"
        [disabled]="isDisabled"
        [ngModel]="format === TimeFormat.twentyFourHours ? selectedTime : (selectedTime | plTwentyFourHoursToAmPm)"
      />
      <pl-icon
        *ngIf="icon"
        [frame]="IconFrame.round"
        [name]="icon"
        class="h-10 w-10 cursor-pointer border-transparent bg-transparent"
        [ngClass]="{
          'text-pl-gray-300': isDisabled
        }"
      />
    </div>

    <mat-hint
      *ngIf="controlDir.control?.errors && controlDir?.control?.dirty && isFormSubmitted"
      align="start"
      class="text-xs text-pl-error"
    >
      <span *ngIf="controlDir.control?.errors?.['required']">{{ 'errors.required_enter_value' | translate }}</span>
    </mat-hint>
  </mat-form-field>
</div>

<pl-popover
  [show]="showMenu()"
  [positionX]="PositionX.start"
  [positionY]="PositionY.below"
  (dismissed)="closeMenu()"
  [bindingElement]="inputElement"
>
  <div @opacity *ngIf="showMenu()" class="w-[200px] h-[200px] overflow-x-auto">
    <p
      #timeSlotElements
      *ngFor="let timeSlot of timeSlots"
      class="cursor-pointer p-2.5 text-pl-gray-450 hover:bg-pl-gray-300"
      [ngClass]="{ 'bg-pl-gray-250': timeSlot.time === selectedTime }"
      [attr.time]="timeSlot.time"
      (click)="onTimeSlotClicked(timeSlot.time)"
    >
      {{ timeSlot.label }}
    </p>
  </div>
</pl-popover>
